// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-form_wrapper__fQWcQ {
  width: 576px;
}

.schedule-form_fieldsWrapper__1f5i2 > div:not(:first-child) {
  margin-top: 16px;
}

.schedule-form_row__sMeJj {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.schedule-form_select__15hCq {
  min-width: 160px;
}`, "",{"version":3,"sources":["webpack://./src/components/wttp/templates/schedule-form/index.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".wrapper {\n  width: 576px;\n}\n\n.fieldsWrapper > div:not(:first-child) {\n  margin-top: 16px;\n}\n\n.row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.select {\n  min-width: 160px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `schedule-form_wrapper__fQWcQ`,
	"fieldsWrapper": `schedule-form_fieldsWrapper__1f5i2`,
	"row": `schedule-form_row__sMeJj`,
	"select": `schedule-form_select__15hCq`
};
export default ___CSS_LOADER_EXPORT___;
